import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class PatFail extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.PAT &&
            fragment.associatedState === FootballState.PatMissed
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        this.switchPossession(gameContext);
    }

    switchPossession() {}
}
